.sticky-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: var(--background);
  z-index: 1000;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0);
}

.sticky-header.is-sticky {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  max-width: 1400px;
  margin: 0 auto;
  height: 60px;
}

.logo-section {
  flex: 0 0 auto;
  margin-right: 1rem;

  img {
    height: 40px;
    width: auto;
  }
}

.search-form {
  background: var(--search-input);
  border-radius: 4px;
  display: flex;
  align-items: center;
  min-width: 300px;
  /* max-width: 660px; */
  position: relative;
  flex-grow: 1;

  .search-icon {
    width: 20px;
    height: 20px;
    margin: 0 16px;
    color: var(--input-placeholder);
  }

  .search-input {
    background: transparent;
    color: var(--input-placeholder);
    font-family: "Source Sans Pro", "Helvetica", sans-serif;
    font-size: 14px;
    font-weight: 600;
    height: 40px;
    max-width: 660px;
    width: calc(100% - 52px);
    border: none;
    padding: 0;
    transition: border .3s ease;

    &::placeholder {
      color: var(--input-placeholder);
    }
  }
}

.navigation {
  flex: 0 1 auto;
  display: flex;
  gap: 16px;
  margin: 0 1rem;
}

.navigation a {
  color: var(--text-body);
  font-weight: 600;
  text-decoration: none;
  font-size: 16px;
}

.navigation a:hover {
  transition: .3s ease;
  color: var(--primary-hover);
}